import dateToString from '../../../function/dateToString';
import MultiChoiceItem from '../../../types/MultiChoiceItem';
import getCheckedMultiChoiceData from './getCheckedMultiChoiceData';
import isAnyItemUnchecked from './isAnyItemUnchecked';

type ReturnType = {
  targetUrl: string;
  isSelectedFilter: boolean;
};

const addArrayQueryToParams = (
  params: string[],
  data: MultiChoiceItem[],
  label: string,
  withoutId?: string,
): void => {
  if (data) {
    const values = data.filter(({ id }) => id !== withoutId);
    if (isAnyItemUnchecked(data)) {
      const checkedValues = getCheckedMultiChoiceData(values);
      params.push(`${label}=${checkedValues.join(',')}`);
    }
  }
};

export default (
  page: number,
  perPage: number,
  searchText: string,
  from: Date,
  to: Date,
  typ: MultiChoiceItem[],
  stav: MultiChoiceItem[],
  priradeny: MultiChoiceItem[],
  isNepriradeny: boolean,
  pripomienkujuciSubjekt: MultiChoiceItem[],
  routeList: string,
): ReturnType => {
  const params = [];
  let isSelectedFilter = false;

  if (searchText) {
    params.push(`text=${searchText}`);
  }
  if (from) {
    params.push(`from=${dateToString(from)}`);
  }

  if (to) {
    params.push(`to=${dateToString(to)}`);
  }

  addArrayQueryToParams(params, typ, 'typ');
  addArrayQueryToParams(params, stav, 'stav');
  addArrayQueryToParams(params, priradeny, 'priradeny', 'isNepriradeny');

  if (!isNepriradeny) {
    params.push(`isNepriradeny=${isNepriradeny}`);
  }

  addArrayQueryToParams(params, pripomienkujuciSubjekt, 'subjekt');

  if (params.length > 0) {
    isSelectedFilter = true;
  }

  if (page) {
    params.push(`page=${page}`);
  }

  if (perPage) {
    params.push(`perPage=${perPage}`);
  }

  return { targetUrl: `${routeList}/?${params.join('&')}`, isSelectedFilter };
};
